import { render } from "./CompetenciesContent.vue?vue&type=template&id=7364a7bd&ts=true"
import script from "./CompetenciesContent.vue?vue&type=script&lang=ts"
export * from "./CompetenciesContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__